import { render, staticRenderFns } from "./MemberImagesTab.vue?vue&type=template&id=9412d606&"
import script from "./MemberImagesTab.vue?vue&type=script&lang=js&"
export * from "./MemberImagesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports